import { Button, Popover, Stack, Typography } from '@mui/material';

import { Labels } from '@/models/labels';

import { buildTooltipText } from '../utils/text';

type Props = {
  label: Labels.Details | null;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onConfirm: () => void;
};

const PAPER_SX = {
  mt: 1,
  width: 320,
  p: 2,
  borderTop: 3,
  borderColor: 'error.main'
};

export const RemoveLabelPopover = ({
  label,
  anchorEl,
  onClose,
  onConfirm
}: Props) => (
  <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    slotProps={{ paper: { sx: PAPER_SX } }}
  >
    <Stack gap={0.5}>
      <Typography variant="subtitle1" fontWeight={700}>
        Remove “{label?.name}”?
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label && buildTooltipText(label, false)}. It stays in the workspace and
        on other posts.
      </Typography>
    </Stack>
    <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
      <Button color="inherit" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="contained" color="error" onClick={onConfirm}>
        Remove
      </Button>
    </Stack>
  </Popover>
);
